import { type GA4ProductItemInput, type MapListProductToGA4ItemArgs } from '../ga4ProductModel';

import type { CarouselProductMapperProps } from '@/services/mappers/common/carouselProductMapper';

export type ListProductMapperProps = CarouselProductMapperProps;

export const mapListProductToGA4Item = ({
  product,
  locationId,
  index,
  itemListId,
  itemListName,
  isListEvent,
}: MapListProductToGA4ItemArgs<ListProductMapperProps>): GA4ProductItemInput => ({
  locationId,
  index,
  itemListId,
  itemListName,
  isListEvent,
  id: product.code,
  name: product.name ?? product.displayName,
  brand: product.brand?.name,
  variant: product.sku,
  price: product.price.sellingPrice,
  color: product.color,
  discountSigning: product.discountSigning,
  discount: product.tracking.discount,
  categoryPath: product.tracking.categoryPath,
  variantStock: product.tracking.purchasable,
});
